import videojs from 'video.js';

const Button = videojs.getComponent('Button');

/**
 *
 * @ignore
 */
class SubdivisionsContainerArrowLeft extends Button {
  buildCSSClass() {
    return `${super.buildCSSClass()} srgssr-subdivisions__arrow subdivisions-arrow-prev`;
  }

  createEl() {
    return super.createEl('button', {
      className: this.buildCSSClass(),
      tabIndex: -1,
    }, {
      'aria-hidden': true,
    });
  }

  // eslint-disable-next-line
  handleClick(e) {
    e.preventDefault();
  }
}

videojs.registerComponent('SubdivisionsContainerArrowLeft', SubdivisionsContainerArrowLeft);
export default SubdivisionsContainerArrowLeft;
